import type { Item } from '@grnhse/seedling/lib/birch/components/forms/dropdown/item';
import type AdvancedFilter from 'talent_matching/components/filters/advanced_filter';
import {
  AppliedOnType,
  DEFAULT_EXCLUDE_MATCH,
  type ExcludeMatch,
} from 'talent_matching/types';

const REDISCOVERY_FORM_DEFAULTS = {
  can_have: [] as string[],
  must_have: [] as string[],
  does_not_have: [] as string[],
  does_not_have_match: DEFAULT_EXCLUDE_MATCH as ExcludeMatch,
  milestone: null as Item | null,
  stages: null as Item[] | null,
  include_rejection_reasons: [] as Item[],
  exclude_rejection_reasons: [] as Item[],
  scorecard_performance: null as Item | null,
  scorecard_attribute_filters: [] as Item[],
  scorecard_attribute_match: null as string | null,
  no_strong_no_scores: false,
  recently_active_in_my_greenhouse: false,
  exclude_hired: false,
  exclude_rejected: false,
  exclude_current_job_people: false,
  without_candidate_tags: [] as Item[],
  appliedOnStart: null as string | null,
  appliedOnEnd: null as string | null,
  appliedOnType: null as AppliedOnType | null,
  jobs: [] as Item[],
  departments: [] as Item[],
  offices: [] as Item[],
  advancedFilters: [] as AdvancedFilter[],
};

export type RediscoveryFormValues = typeof REDISCOVERY_FORM_DEFAULTS;

export const REDISCOVERY_FORM_FIELD_KEYS = Object.keys(
  REDISCOVERY_FORM_DEFAULTS
) as (keyof RediscoveryFormValues)[];

export type RediscoveryPageDefaults = RediscoveryFormValues & {
  user_date_format: string;
  page: number;
  perPage: number;
};

export type GreenhouseFilterPreset = {
  label: string;
  value: string;
  shortLabel?: string;
  filterValues: Record<string, unknown>;
};
